module.exports = __webpack_public_path__ + "img/coingate.39ff4795.svg";